export enum NotificationTypes {
  Error = "error",
  Success = "success",
  Info = "info",
}
